import gsap from 'gsap';

export class LightBox {
	constructor() {
		this.overlaySlot = null;
		this.overlayMask = null;
		this.funcClick = [];
		this.init();
	}

	init() {
		const allElements = document.querySelectorAll( '[data-mk-lightbox]' );
		if ( ! allElements?.length ) return;
		this.overlaySlot = document.querySelector( '.mk-overlay-slot' );
		this.overlayMask = document.querySelector( '.mk-overlay-mask' );
		allElements.forEach( ( element, index ) => {
			const clickFunc = () => {
				this.click( element );
			};
			this.funcClick[ index ] = clickFunc;
			element.addEventListener( 'click', this.funcClick[ index ] );
		} );
	}

	click( element ) {
		const getSrc = element.dataset.mkLightboxSrc;
		this.openLightBox( getSrc );
	}

	openLightBox( theImage ) {
		if ( ! this.overlaySlot ) return;
		document.body.classList.add( 'modal-open' );
		const isExist = this.overlaySlot.querySelector( '.mk-lightbox' );
		if ( ! isExist ) {
			const newLightbox = document.createElement( 'div' );
			newLightbox.className = 'mk-lightbox';

			// 创建内部容器
			const theContainer = document.createElement( 'div' );
			theContainer.className = 'el-container';
			theContainer.addEventListener( 'click', ( e ) => {
				e.stopPropagation();
			} );

			const theClose = document.createElement( 'div' );
			theClose.className = 'el-close';
			theClose.innerHTML =
				'<svg xml:space="preserve" viewBox="0 0 32 32"><path d="M25.6 5 5 25.6 6.4 27 27 6.4 25.6 5zm-11 8.2L6.4 5 5 6.4l8.2 8.2 1.4-1.4zm2.8 5.6 8.2 8.2 1.4-1.4-8.2-8.2-1.4 1.4z"/></svg>';
			newLightbox.addEventListener( 'click', () => {
				this.closeLightBox( newLightbox );
			} );

			const imageElement = document.createElement( 'img' );
			imageElement.src = theImage;
			imageElement.alt = '图片描述';

			theContainer.appendChild( imageElement );
			newLightbox.appendChild( theContainer );
			newLightbox.appendChild( theClose );
			this.overlaySlot.appendChild( newLightbox );
			gsap.fromTo(
				this.overlayMask,
				{ display: 'none', opacity: 0 },
				{ display: 'block', opacity: 1 }
			);
		}
	}

	closeLightBox( theLightbox ) {
		document.body.classList.remove( 'modal-open' );
		gsap.fromTo(
			this.overlayMask,
			{ display: 'block', opacity: 1 },
			{ display: 'none', opacity: 0 }
		);
		theLightbox.parentNode.removeChild( theLightbox );
	}
}
